[{
      "display": "true",
      "ui_columnname": "action",
      "db_columnname": "action",
      "datatype": "char",
      "mappingkey": "action",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "customer Id",
      "db_columnname": "customerId",
      "datatype": "char",
      "mappingkey": "customerId",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "customer Name",
      "db_columnname": "customerName",
      "datatype": "char",
      "mappingkey": "customerName",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "Acronym",
      "db_columnname": "customerAcronym",
      "datatype": "char",
      "mappingkey": "customerAcronym",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "Account Code",
      "db_columnname": "clearingAccountCode2",
      "datatype": "char",
      "mappingkey": "clearingAccountCode2",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "RSMS ACCT Code",
      "db_columnname": "clearingAccountCode",
      "datatype": "char",
      "mappingkey": "clearingAccountCode",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "order Count",
      "db_columnname": "orderCount",
      "datatype": "Int",
      "mappingkey": "orderCount",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "MTD Avg",
      "db_columnname": "MTDAvgCount",
      "datatype": "Int",
      "mappingkey": "MTDAvgCount",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "30 DMA",
      "db_columnname": "thirtyDayMovingAvg",
      "datatype": "Int",
      "mappingkey": "thirtyDayMovingAvg",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   },
   {
      "display": "true",
      "ui_columnname": "report Date",
      "db_columnname": "reportDate",
      "datatype": "char",
      "mappingkey": "reportDate",
      "dropdown": "NO",
      "isdefault": "false",
      "disabled": "true",
      "value": "",
      "dropdowntype": "singleselect",
      "dropdownvalue": ""
   }
]